import React from 'react';
import useStyles from './ProcessButtonsWrapper.style';

const ProcessButtonsWrapper: React.FC = ({ children }) => {
  const c = useStyles({});

  return (
    <div className={c.root}>
      {children}
    </div>
  );
};

export { ProcessButtonsWrapper };
